import type { authData } from '../entities/AuthData'
const loggedUserRedirect = (userData: authData): string => {
  const returnUrlCookie = useCookie('returnUrl')
  const returnUrl = returnUrlCookie.value
  returnUrlCookie.value = null
  const { FEATURE_FLAG_B2B_NEW_FUNNEL } = useRuntimeConfig().public

  if (userData.userType.toLowerCase() === 'owner') {
    if (userData.isOwnerRegister) {
      // TODO: Delete the Feature Flag once is stable in production
      return FEATURE_FLAG_B2B_NEW_FUNNEL
        ? routes().ownerCottageNew({ ownerId: userData.userId })
        : routes().ownerNewCottage({ ownerId: userData.userId })
    } else if (returnUrl && routesValidation().isOwnerRoute(returnUrl)) {
      return returnUrl
    }

    return routes().calendarQuickRentUnit({
      ownerId: userData.userId,
    })
  } else {
    if (returnUrl) {
      return returnUrl
    }
    return routes().home()
  }
}

export default loggedUserRedirect
